import { render } from "./ModalHomologa.vue?vue&type=template&id=1b20c592&scoped=true"
import script from "./ModalHomologa.vue?vue&type=script&lang=js"
export * from "./ModalHomologa.vue?vue&type=script&lang=js"

import "./ModalHomologa.vue?vue&type=style&index=0&id=1b20c592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b20c592"]])

export default __exports__